/**
 * BodyDispatcher — selects the right per-operation body component
 * for an expanded VersionCard. Commit 9 closes out coverage: every
 * `OperationType` now routes to a real body.
 */
import React from 'react';
import { VersionRecord } from '../../state/types';
import AddBody from './AddBody';
import UpdateBody from './UpdateBody';
import DeleteBody from './DeleteBody';
import RestoreBody from './RestoreBody';
import BaselineSnapshotBody from './BaselineSnapshotBody';
import ReviseRecompletionBody from './ReviseRecompletionBody';

interface BodyDispatcherProps {
  version: VersionRecord;
}

export default function BodyDispatcher({ version }: BodyDispatcherProps) {
  switch (version.operation_type) {
    case 'add':
      return <AddBody version={version} />;
    case 'update':
      return <UpdateBody version={version} />;
    case 'delete':
      return <DeleteBody version={version} />;
    case 'restore':
      return <RestoreBody version={version} />;
    case 'baseline':
    case 'snapshot':
      return <BaselineSnapshotBody version={version} />;
    case 'revise_recompletion':
      return <ReviseRecompletionBody version={version} />;
  }
}
